// Copyright (c) 2020 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import * as Firebase from "firebase";
import { DocBase, HasUid, HasName, Uid } from "./schema";
import { logIfErrorA } from "../log";
import { createOuts } from "../util";

type DocumentReference = firebase.firestore.DocumentReference;
type Query = Firebase.firestore.Query;
type QuerySnapshot = Firebase.firestore.QuerySnapshot;

const { info } = createOuts("Api", true);

export async function saveWithHistory<Data>(
  ref: DocumentReference,
  doc: DocBase<Data>
): Promise<void> {
  info(`Saving to '${ref.path}':`, doc);
  await ref.set(doc);

  const historyRef = ref.collection("history").doc(doc.timestamp);
  info(`Saving history '${historyRef.path}':`, doc);
  await historyRef.set(doc);
}

export function queryData(snap: QuerySnapshot) {
  return snap.docs.map(x => x.data());
}

export async function query<T>(caller: string, query: Query): Promise<T[]> {
  const snap = await logIfErrorA(caller, () => query.limit(1000).get());
  return snap.docs.map(x => x.data()) as T[];
}

export function nameOf<T extends HasUid & HasName>(
  uid: string | null | undefined,
  index: Map<Uid, T>
): string {
  if (uid == null) {
    return "Loading..";
  }
  const item = index.get(uid);
  return (item == null) ? "Loading.." : item.name;
}
